import type { CustomErrorRule } from '@/core/error/transport/types'
import { EndpointsEnum } from '@/services/endpoints'
import { TmApiSenderIdMarkAsPendingError } from '@/core/error/transport/tmApiSenderIdMarkAsPendingError'

export const senderIdMarkAsPendingErrorRule: CustomErrorRule = {
  endpoint: EndpointsEnum.senderIds,
  subCodes: ['user.sender.mark_as_pending'],
  klass: TmApiSenderIdMarkAsPendingError,
}
